import { render, staticRenderFns } from "./ForgotStepTwo.vue?vue&type=template&id=8ca4a028&scoped=true&"
import script from "./ForgotStepTwo.vue?vue&type=script&lang=js&"
export * from "./ForgotStepTwo.vue?vue&type=script&lang=js&"
import style0 from "./ForgotStepTwo.vue?vue&type=style&index=0&id=8ca4a028&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ca4a028",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VOtpInput } from 'vuetify/lib/components/VOtpInput';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VDialog,VForm,VOtpInput,VRow})
